import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import HelpIcon from '@mui/icons-material/HelpOutlineRounded';

const styles = theme => ({
    button: {
        padding: 0,
        marginLeft: 5,
        cursor: 'default',
        color: theme.palette.text.secondary
    },
    icon: {
        fontSize: 18
    }
});

class TooltipHelpButton extends React.Component {
    render() {
        const { classes, title, placement } = this.props

        return (
            <Tooltip
                title={title}
                enterTouchDelay={0}
                placement={placement ? placement : 'top'}
                arrow
            >
                <IconButton
                    className={classes.button}
                    disableRipple
                    aria-label='Show helper text'
                    size="large"
                >
                    <HelpIcon
                        className={classes.icon}
                    />
                </IconButton>
            </Tooltip>
        );
    }
}

export default withStyles(TooltipHelpButton, styles);